export default "__VITE_ASSET__vOHmFuJo__"